'use strict';

exports.__esModule = true;

var _Perimeter = require('./Perimeter');

var _Perimeter2 = _interopRequireDefault(_Perimeter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a new instance of Perimeter.
 */
var createPerimeter = function createPerimeter() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new (Function.prototype.bind.apply(_Perimeter2.default, [null].concat(args)))();
};

exports.default = createPerimeter;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/createPerimeter.js
// module id = /nMR
// module chunks = 0